import React, { Component } from 'react';
import Vehicles from '../../newVehicles';
import MarineCatalog from './MarineCatalog';
import { ASSET_TYPES } from '../../../util/assetType';
import { isMarineVisible } from '../../../util/marineCapability';

/**
 * The /vehicles route host — Road (vehicle catalog) and Water (marine catalog).
 *
 * Owns `assetType` and nothing else. Switching modes UNMOUNTS one and mounts
 * the other, so neither mode ever has to reconcile the other's state.
 *
 * The pill is gated on `isMarineVisible()`, the same gate as the walk-in
 * Road/Water toggle. With marine hidden this renders <Vehicles> and a
 * fragment, so /vehicles is byte-identical to what it was before marine
 * existed.
 */
export default class AssetCatalogPage extends Component {
  state = { assetType: ASSET_TYPES.AUTO };

  setMode = (assetType) => {
    if (assetType !== this.state.assetType) this.setState({ assetType });
  };

  renderModeToggle() {
    const isRoad = this.state.assetType === ASSET_TYPES.AUTO;
    return (
      <div className="text-center mb-3">
        <div className="jv-segmented" role="group" aria-label="Asset type">
          <button
            type="button"
            aria-pressed={isRoad}
            className={`jv-segmented__btn ${isRoad ? 'is-active' : ''}`}
            onClick={() => this.setMode(ASSET_TYPES.AUTO)}
          >
            Road
          </button>
          <button
            type="button"
            aria-pressed={!isRoad}
            className={`jv-segmented__btn ${!isRoad ? 'is-active' : ''}`}
            onClick={() => this.setMode(ASSET_TYPES.MARINE)}
          >
            Water
          </button>
        </div>
      </div>
    );
  }

  render() {
    const marineVisible = isMarineVisible();
    const isRoad = !marineVisible || this.state.assetType === ASSET_TYPES.AUTO;

    return (
      <React.Fragment>
        {marineVisible && this.renderModeToggle()}
        {/* Spread, not four named props: the route also passes react-router's
            match/location/history through, and dropping them would silently
            change what <Vehicles> receives. */}
        {isRoad ? <Vehicles {...this.props} /> : <MarineCatalog userRole={this.props.userRole} />}
      </React.Fragment>
    );
  }
}
